import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {GetPipelineConfigSpecType} from 'pipelines/StepShapeUtils';
import {ButtonSize} from 'ui-library/buttons/Button';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import SearchableMenu from 'ui-library/menus/SearchableMenu';
import {JSONValue} from 'util/Types';

import {EnumUISchema} from '../StepConfigEditorTypes';

interface EnumEditorProps {
  config: string | number | null;
  configShape: GetPipelineConfigSpecType<'enum'>;
  onChangeConfig: (config: JSONValue) => void;
  uiSchema?: EnumUISchema;
  disabled?: boolean;
  buttonSize?: ButtonSize;
}

export default function EnumEditor({
  config,
  configShape,
  onChangeConfig,
  uiSchema,
  disabled,
  buttonSize = ButtonSize.MEDIUM,
}: EnumEditorProps): JSX.Element {
  function getEnumOptionDisplayName(enumOption: string | number): string {
    return uiSchema?.displayNames?.[enumOption] ?? String(enumOption);
  }

  const placeholder = uiSchema?.placeholder ?? 'Select an option';

  return (
    <SelectDropdown
      displayName={config != null ? getEnumOptionDisplayName(config) : placeholder}
      menu={
        <SearchableMenu
          height={Menu.HEIGHTS.MEDIUM}
          width={Menu.WIDTHS.FIT_CONTENT}
          scrollable={true}
          optionDatas={configShape.choices.map((choice) => ({
            name: getEnumOptionDisplayName(choice),
            value: choice,
          }))}
          selectedValue={config}
          onSelect={(value) => {
            onChangeConfig(value ?? null);
          }}
        />
      }
      className={css(styles.grow)}
      buttonSize={buttonSize}
      disabled={disabled}
    />
  );
}

const styles = StyleSheet.create({
  grow: {
    flexGrow: 1,
  },
});
